export const API_BASE = 'https://norma.nomoreparties.space';
export const PASSWORD_RESTORE_PATH = '/api/password-reset';
export const PASSWORD_RESET_PATH = '/api/password-reset/reset';
export const REGISTER_PATH = '/api/auth/register';
export const LOGIN_PATH = '/api/auth/login';
export const LOGOUT_PATH = '/api/auth/logout';
export const TOKEN_PATH = '/api/auth/token';
export const USER_PATH = '/api/auth/user';
export const API_URL = `${API_BASE}/api/ingredients`;
export const ORDER_URL = `${API_BASE}/api/orders`;
export const WS_URL = 'wss://norma.nomoreparties.space/orders/all';
export const WS_USER_URL = 'wss://norma.nomoreparties.space/orders';

export const BUN_NAME = 'bun';
export const SAUCE_NAME = 'sauce';
export const MAIN_NAME = 'main';
export const BLANK_GIF =
    'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
